export const PHONE_COUNTRIES = [
  { code: "BR", name: "Brazil", dialCode: "+55", flag: "🇧🇷", example: "11912345678" },
  { code: "US", name: "United States", dialCode: "+1", flag: "🇺🇸", example: "4155550123" },
  { code: "CA", name: "Canada", dialCode: "+1", flag: "🇨🇦", example: "4165550123" },
  { code: "GB", name: "United Kingdom", dialCode: "+44", flag: "🇬🇧", example: "7700900123" },
  { code: "PT", name: "Portugal", dialCode: "+351", flag: "🇵🇹", example: "912345678" },
  { code: "ES", name: "Spain", dialCode: "+34", flag: "🇪🇸", example: "612345678" },
  { code: "FR", name: "France", dialCode: "+33", flag: "🇫🇷", example: "612345678" },
  { code: "DE", name: "Germany", dialCode: "+49", flag: "🇩🇪", example: "15123456789" },
  { code: "IT", name: "Italy", dialCode: "+39", flag: "🇮🇹", example: "3123456789" },
  { code: "AU", name: "Australia", dialCode: "+61", flag: "🇦🇺", example: "412345678" },
  { code: "IN", name: "India", dialCode: "+91", flag: "🇮🇳", example: "9876543210" },
];

const getDigits = (value = "") => String(value).replace(/\D/g, "");
const getPhoneCharacters = (value = "") =>
  String(value).replace(/[^\d*]/g, "");

export const isMaskedPhone = (phone = "") => String(phone).includes("*");

const sortedCountries = [...PHONE_COUNTRIES].sort(
  (a, b) => b.dialCode.length - a.dialCode.length || a.code.localeCompare(b.code),
);

export const getCountryByCode = (code = "BR") =>
  PHONE_COUNTRIES.find((country) => country.code === code) || PHONE_COUNTRIES[0];

export const getCountryFromPhone = (phone = "", fallbackCode = "BR") => {
  const digits = getDigits(phone);
  if (!digits) return getCountryByCode(fallbackCode);

  const matches = sortedCountries.filter((country) =>
    digits.startsWith(country.dialCode.replace(/\D/g, "")),
  );

  if (matches.length === 0) {
    return getCountryByCode(fallbackCode);
  }

  const preferredMatch = matches.find((country) => country.code === fallbackCode);
  return preferredMatch || matches[0];
};

export const getNationalNumberFromPhone = (phone = "", fallbackCode = "BR") => {
  const phoneCharacters = getPhoneCharacters(phone);
  if (!phoneCharacters) return "";

  const country = getCountryFromPhone(phone, fallbackCode);
  const dialDigits = country.dialCode.replace(/\D/g, "");

  if (phoneCharacters.startsWith(dialDigits)) {
    return phoneCharacters.slice(dialDigits.length);
  }

  return phoneCharacters;
};

export const buildPhoneValue = (countryCode, nationalNumber) => {
  const country = getCountryByCode(countryCode);
  const digits = getDigits(nationalNumber);

  if (!digits) return "";

  return `${country.dialCode}${digits}`;
};

export const getInitialPhoneParts = (phone = "", fallbackCode = "BR") => ({
  countryCode: getCountryFromPhone(phone, fallbackCode).code,
  nationalNumber: getNationalNumberFromPhone(phone, fallbackCode),
});
